var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-points"},[_vm._l((_vm.dataList),function(item,i){return [_c(item.type === 'history' ? _vm.historyCmp : _vm.replayCmp,{key:i + item.type + item.data.id,tag:"component",attrs:{"data":item.data}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }